<template>
  <div class="paradise-home">
    <div class="welcome">欢迎,{{ nickname }}</div>
    <div class="contentBox">
      <!-- <div class="contentItem" v-for="item in menuList" :key="item.id">
        <div class="title">{{ item.title }}</div>
        <div class="content">
          <div
            class="item"
            v-for="i in item.children"
            :key="i.id"
            @click="routerJump('/' + i.path)"
          >
            <XIcon
              :type="i.bigIcon"
              size="54"
              class="bigIcon"
              v-if="i.bigIcon"
            ></XIcon>
            <img src="./assets/user.png" alt="" v-else />

            <div>{{ i.title }}</div>
          </div>
        </div>
      </div> -->
      <Modal :title="绑定手环" v-model="dictModalVisible" :mask-closable="false" :width="1200">
        <div style="margin-top: 40px; margin-bottom: 10px;text-align: center; font-size: 20px;">查询/绑定手环</div>
        <Form ref="dictForm" :model="dictForm" :label-width="85" :rules="dictFormValidate">

          <Row :gutter="32">
            <Col span="16">

            <FormItem label="手环id" prop="innerId">
              <Input v-model="dictForm.innerId" placeholder="请将手环放在读卡器上，操作过程中不要离开" :disabled="true" />
            </FormItem>
            </Col>

            <Col span="8">
            <Button type="primary" @click="queryBindBracelet">查询绑定情况</Button>
            </Col>

            <Col span="16">
            <FormItem label="手机号" prop="phone" class="block-tool">
              <Input v-model="dictForm.phone" clearable @on-change="onPhoneChange" />
            </FormItem>
            </Col>
            <Col span="8">
            <Button type="primary" @click="queryBindPhone">查询绑定情况</Button>
            </Col>
            <Col span="16">
            <FormItem label="昵称" prop="nickname">
              <Input v-model="dictForm.nickname" clearable @on-change="onNickNameChange" />
            </FormItem>
            </Col>
            <Col span="8">
            <Button type="primary" @click="queryBindName">查询绑定情况</Button>
            </Col>
          </Row>
        </Form>
        <!-- <div slot="footer"> -->
        <div style="margin-bottom: 10px;text-align: center;">
          <!-- <Button type="text" @click="dictModalVisible = false">取消</Button> -->
          <Button type="primary" @click="handleSubmit">绑定手环</Button>
        </div>

        <div slot="footer">
        </div>
        <div>
          <BraceletBind ref="BraceletBind"></BraceletBind>
        </div>

      </Modal>

      <Button style="margin-right: 5px" @click="clickBraceHandle" type="primary"
        icon="ios-create-outline">查询/绑定手环</Button>
    </div>
  </div>
</template>

<script>

import jinmabracelet from "../../../../public/jinmabraceletmanagement.umd.min.js"
import "../../../../public/jinmabraceletmanagement.css"

if (window.jinmabracelet == null) {
  window.jinmabracelet = jinmabracelet;
  console.log("jinmabracelet:", jinmabracelet);
}
let BraceletBind = window.jinmabracelet.components.BraceleManagementBind;

import { getCurrentBraceId, bindCurrentBraceId } from "@/api/index";
var timerId = null;
var checkTimerId = null;
var enableCheckTimerId = true;
function handleFn() {
  console.log("browers hidden");

  if (timerId != null) {
    console.log("close brace timer2");
    clearTimeout(timerId);
    // clearInterval(this.timerId);
  }
  timerId = null;
}
export default {
  name: "paradise-home",
  data() {
    return {
      dictForm: {

      },
      searchTimer: null,
      dictModalVisible: false,
      dictFormValidate: {
        // innerId: [
        //   { required: true, message: '请使用设备读取手环Id', trigger: 'change' }
        // ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' }
        ]
      },
    };
  },

  components: {
    BraceletBind,
  },
  computed: {
    nickname() {
      return this.$store.state.user.nickname;
    },
    // menuList() {
    //   return this.$store.state.app.menuList.filter(
    //     (item) => item.title != "首页"
    //   );
    // },
  },
  methods: {
    onPhoneChange() {
      if (this.searchTimer != null) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },
    onNickNameChange() {
      if (this.searchTimer != null) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },
    handleSubmit() {
      if (this.searchTimer != null) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.$refs.dictForm.validate(valid => {
        if (valid) {
          bindCurrentBraceId(this.dictForm).then(res => {
            if (res.success) {
              this.$Message.success("操作成功");
              this.$nextTick(() => {
                this.queryBindBracelet();
                this.searchTimer = setTimeout(() => {
                  this.dictForm.phone = "";
                  this.dictForm.nickname = "";
                }, 20000);
              })
            } else {
              this.$Message.error(res.message);
              this.searchTimer = setTimeout(() => {
                this.dictForm.phone = "";
                this.dictForm.nickname = "";
              }, 20000);
            }
          });
        }
      });
    },
    clickBraceHandle() {
      this.dictModalVisible = true;
      this.startTimer();
    },
    queryBindBracelet(val) {
      this.$refs.BraceletBind.setBraceletId(this.dictForm.innerId);
    },

    queryBindPhone(val) {

      if (this.searchTimer != null) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.$refs.BraceletBind.setPhone(this.dictForm.phone);
    },

    queryBindName(val) {
      if (this.searchTimer != null) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.$refs.BraceletBind.setNickName(this.dictForm.nickname);
    },
    getInnerId(callback) {
      getCurrentBraceId({}).then(res => {
        if (res.success) {
          this.dictForm.innerId = res.result.innerId;
          // console.log("form ",this.dictForm)
          this.$forceUpdate();
        }
        callback();
      })
    },
    startTimer() {
      this.cancelTimer();
      this.timerQueryBrace();
    },
    timerQueryBrace() {
      if (this.dictModalVisible) {

        if (timerId == null) {
          timerId = setTimeout(() => {
            console.log("query brace timer");
            this.cancelTimer();
            this.getInnerId(() => {
              this.timerQueryBrace();
            })
          }, 2000)
        }
      }
    },
    cancelTimer() {
      if (timerId != null) {
        console.log("close brace timer");
        clearTimeout(timerId);
        // clearInterval(this.timerId);
      }
      timerId = null;
    },
    startCheckTimer() {
      this.cancelCheckTimer();
      if (checkTimerId == null) {
        checkTimerId = setInterval(() => {
          if (enableCheckTimerId) {
            this.timerQueryBrace();
          }
        }, 4000);
      }
    },
    cancelCheckTimer() {
      if (checkTimerId != null) {
        console.log("cancel check timer id");
        clearInterval(checkTimerId);
        // clearInterval(this.timerId);
      }
      checkTimerId = null;
    },
    // routerJump(v) {
    //   if (v == "") return;
    //   this.$router.push({
    //     path: v,
    //   });
    // },
  },
  created() {
    /*浏览器标签页切换会触发"visibilitychange"事件*/
    document.addEventListener("visibilitychange", e => {
      console.log("visibilitychange ", document.visibilityState);
      if (document.visibilityState === "hidden") {
        handleFn()
        enableCheckTimerId = false;

      } else if (document.visibilityState === "visible") {
        enableCheckTimerId = true;
      }
    })
    /*浏览器关闭、浏览器标签页关闭、浏览器刷新均会触发"beforeunload"事件*/
    window.addEventListener('beforeunload', e => handleFn())
  },
  mounted() {
    console.log("home page mounted");
    this.startTimer();
    this.startCheckTimer();
  },

  beforeDestroy() {
    console.log("beforeDestory home page");
    this.cancelTimer();
    this.cancelCheckTimer();
    /*remove掉上面对应的"visibilitychange"事件监听*/
    document.removeEventListener("visibilitychange", e => {
      if (document.visibilityState === "hidden") {
        handleFn()
      }
    })
    /*remove掉上面对应的"beforeunload"事件监听*/
    window.removeEventListener('beforeunload', e => handleFn())
  },
};
</script>

<style lang="less" scoped>
.welcome {
  font-size: 24px;
  font-weight: 700;
  padding: 18px 10px;
}

.contentBox {
  background: #fff;
  border-radius: 4px;
  padding: 18px;

  .contentItem {
    height: 148px;
    font-size: 16px;
    color: #000;

    .content {
      display: flex;
      flex-wrap: wrap;

      .item {
        margin-top: 18px;
        position: relative;
        display: flex;
        height: 86px;
        width: 240px;
        border: 1px solid #f4f4f4;
        border-radius: 4px;
        margin-right: 16px;
        cursor: pointer;

        img {
          width: 54px;
          height: 54px;
          position: relative;
          margin-left: 16px;
          top: 50%;
          transform: translateY(-50%);
        }

        .bigIcon {
          width: 54px;
          height: 54px;
          position: relative;
          margin-left: 16px;
          top: 50%;
          transform: translateY(-50%);
        }

        &>div {
          left: 82px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>